module.exports = __webpack_public_path__ + "img/diagram-lean-canvas.11230ef8.svg";